import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Treeview } from "admin-lte";
import $ from "jquery";
import UserContext from "../../Contexts/UserContext";
import { toast } from "react-toastify";
import { ConfigService, SurveyService } from "../../Services";
import {
  faAddressBook,
  faAddressCard,
} from "@fortawesome/free-regular-svg-icons";
import {
  faCalendarDays,
  faQuestion,
  faPersonCircleQuestion,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import {
  PermissionConstants,
  RoutePathConstants,
  ProcessStatusEnum,
} from "../../Constants";
import {
  containsAll,
  containsAny,
  toastSuccessMessage,
  downloadFileFromResponse,
} from "wup-module1-base";

function MainSidebar(props) {
  const location = useLocation();
  const { user, setUser } = useContext(UserContext);
  const [knowledgeBase, setKnowledgeBase] = useState();
  const [surveyTypes, setSurveyTypes] = useState();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);


  // funkcja renderująca klasy dla elemntów listy
  const getNavLinkClassNames = (route, routeToExclude) =>
    `nav-link ${
      location.pathname.split("/")[1].toLowerCase() === route.toLowerCase() &&
      (!routeToExclude || location.pathname.split("/")[1].toLowerCase() !== routeToExclude)
        ? " active "
        : ""
    }`;

  // funkcja sprawdzająca czy dany typ ankiety jest dostępny dla użytkowników
  const isTypeActive = (type) => {
    const foundObject = surveyTypes?.find(
      (obj) => obj.type === type && obj.activate === true
    );
    return !!foundObject;
  };

  // funkcja pobierająca pdf
  const downloadFeedbackPDF = () => {
    SurveyService.downloadFeedback(user.id)
      .then((res) => {
        downloadFileFromResponse(res);
        toastSuccessMessage("Pobieranie pliku");
      })
      .catch((error) => {
        toast.error("Błąd pobrania PDF");
      });
  };

  useEffect(() => {
    const updateSidebarState = () => {
      const collapsed = document.body.classList.contains("sidebar-collapse");
      setIsSidebarOpen(!collapsed);
    };

    updateSidebarState();

    const observer = new MutationObserver(updateSidebarState);
    observer.observe(document.body, { attributes: true });

    return () => observer.disconnect();
  }, []);

  // hook inicjujący treeview, pobierajacy bazewiedzy, pobierajacy typy ankiet
  useEffect(() => {
    $('[data-widget="treeview"]').each(function () {
      Treeview._jQueryInterface.call($(this), "init");
    });

    ConfigService.getConfigByKey("knowledge_base")
      .then((response) => {
        setKnowledgeBase(response.data);
      })
      .catch((error) => {
        console.error(error);
      });

    SurveyService.fetchTypes()
      .then((response) => {
        if (!!response.data) {
          setSurveyTypes(response.data);
        } else toast.error("Brak ankiet");
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    !!isSidebarOpen && <aside className="main-sidebar sidebar-dark-primary elevation-4">
      <div
        data-widget="pushmenu"
        className="float-right button-close display-close-link"
      >
        <FontAwesomeIcon icon={faXmark} className="" />
      </div>

      <Link to="/" className="brand-link text-center">
        <span className="brand-text font-weight-light ">Panel klienta</span>
      </Link>

      <div className="sidebar">
        <nav className="mt-2">
          <div>
            <ul
              class="nav nav-pills nav-sidebar flex-column nav-child-indent"
              role="menu"
            >
              {!!!user.isFirstRecrutation && (
                <li className="nav-item">
                  <Link
                    to={`/ApplicationForm`}
                    className={
                      "nav-link " +
                      getNavLinkClassNames(RoutePathConstants.ApplicationForm)
                    }
                  >
                    <FontAwesomeIcon
                      icon={faAddressBook}
                      className="nav-icon"
                      aria-hidden="true"
                    />
                    <p>Zgłoszenie</p>
                  </Link>
                </li>
              )}

              {!(
                user.currentStep < ProcessStatusEnum.OrderingVouchers.value ||
                user.currentStep === ProcessStatusEnum.OrderingVouchers.value ||
                user.currentStep === ProcessStatusEnum.EndWithoutOrder.value
              ) && (
                <li className="nav-item">
                  <Link
                    to={`/ContractForm`}
                    className={
                      "nav-link " +
                      getNavLinkClassNames(RoutePathConstants.ContractForm)
                    }
                  >
                    <FontAwesomeIcon
                      icon={faAddressBook}
                      className="nav-icon"
                    />
                    <p>Umowa o dofinansowanie</p>
                  </Link>
                </li>
              )}

              {!(
                user.currentStep < ProcessStatusEnum.ContractFormv2.value
              ) && (
                <li className="nav-item" >
                  <Link
                    to={`/ContractFormv2`}
                    className={
                      "nav-link " +
                      getNavLinkClassNames(RoutePathConstants.ContractFormv2)
                    }
                  >
                    <FontAwesomeIcon
                      icon={faAddressBook}
                      className="nav-icon"
                    />
                    <p>Druga umowa o dofinansowanie</p>
                  </Link>
                </li>
              )}

              {user.isSurveyActive && (
                <li className="nav-item" >
                  <Link
                    to={`/${RoutePathConstants.Survey}`}
                    className={
                      "nav-link " +
                      getNavLinkClassNames(RoutePathConstants.Survey)
                    }
                  >
                    <FontAwesomeIcon
                      icon={faAddressBook}
                      className="nav-icon"
                    />
                    <p>Autoanaliza</p>
                  </Link>
                </li>
              )}
              {!(
                user.currentStep <
                  ProcessStatusEnum.CompletingBalanceSheetOfModuleFirst.value ||
                user.currentStep ===
                  ProcessStatusEnum.CompletingBalanceSheetOfModuleFirstByAdvisor
                    .value
              ) && (
                <>
                  {user.currentStep > ProcessStatusEnum.Store.value ? (
                    <>
                      <li className="nav-item" >
                        <Link
                          to={`/${RoutePathConstants.StoreSummary}`}
                          className={getNavLinkClassNames(
                            RoutePathConstants.StoreSummary
                          )}
                        >
                          <FontAwesomeIcon
                            icon={faAddressBook}
                            className="nav-icon"
                          />
                          <p>Samoocena</p>
                        </Link>
                      </li>
                      <li className="nav-item" >
                        <Link
                          onClick={downloadFeedbackPDF}
                          className={`nav-link`}
                        >
                          <FontAwesomeIcon
                            icon={faAddressCard}
                            className="nav-icon"
                          />
                          <p>Pobierz informację zwrotną</p>
                        </Link>
                      </li>
                    </>
                  ) : (
                    <li className="nav-item" >
                      <Link
                        to={`/${RoutePathConstants.CompletingBalanceSheetOfModuleFirst}`}
                        className={getNavLinkClassNames(
                          RoutePathConstants.CompletingBalanceSheetOfModuleFirst
                        )}
                      >
                        <FontAwesomeIcon
                          icon={faAddressBook}
                          className="nav-icon"
                        />
                        <p>Samoocena</p>
                      </Link>
                    </li>
                  )}
                </>
              )}
              {!!surveyTypes &&
                !(
                  user.currentStep <
                    ProcessStatusEnum.CompletingBalanceSheetOfModuleSecond
                      .value ||
                  user.currentStep ===
                    ProcessStatusEnum.EndWithoutOrder.value ||
                  !isTypeActive(3) ||
                  (user.fromReserveList && !user.consentToVouchers)
                ) && (
                  <li className="nav-item" >
                    <Link
                      to={`/${RoutePathConstants.CompletingBalanceSheetOfModuleSecond}`}
                      className={getNavLinkClassNames(
                        RoutePathConstants.CompletingBalanceSheetOfModuleSecond
                      )}
                    >
                      <FontAwesomeIcon
                        icon={faAddressBook}
                        className="nav-icon"
                      />
                      <p>Twój cel rozwojowy</p>
                    </Link>
                  </li>
                )}
                {!!surveyTypes &&
                !(
                  user.currentStep <
                    ProcessStatusEnum.CompletingBalanceSheetOfModuleSecondv2
                      .value ||
                  user.currentStep ===
                    ProcessStatusEnum.EndWithoutOrder.value ||
                  !user.isSecondOrderAvailable ||
                  (user.fromReserveList && !user.consentToVouchers)
                ) && (
                  <li className="nav-item" >
                    <Link
                      to={`/${RoutePathConstants.CompletingBalanceSheetOfModuleSecondv2}`}
                      className={getNavLinkClassNames(
                        RoutePathConstants.CompletingBalanceSheetOfModuleSecondv2
                      )}
                    >
                      <FontAwesomeIcon
                        icon={faAddressBook}
                        className="nav-icon"
                      />
                      <p>Twój cel rozwojowy - drugie zamówienie</p>
                    </Link>
                  </li>
                )}
              {knowledgeBase?.value ? (
                <li className="nav-item" >
                  <Link
                    to={knowledgeBase.value}
                    className={getNavLinkClassNames(
                      RoutePathConstants.KnowledgeBase
                    )}
                  >
                    <FontAwesomeIcon
                      icon={faAddressBook}
                      className="nav-icon"
                    />
                    <p>Baza wiedzy</p>
                  </Link>
                </li>
              ) : null}
              {containsAll(user.permissions, [
                PermissionConstants.User_List,
              ]) && (
                <li className="nav-item" >
                  <Link
                    to={`/${RoutePathConstants.User}`}
                    className={getNavLinkClassNames(RoutePathConstants.User)}
                  >
                    <FontAwesomeIcon
                      icon={faAddressBook}
                      className="nav-icon"
                    />
                    <p>Użytkownicy</p>
                  </Link>
                </li>
              )}
              {containsAny(user.permissions, [
                PermissionConstants.User_List,
              ]) && (
                <li className="nav-item" >
                  <Link
                    to={`/${RoutePathConstants.Question}`}
                    className={getNavLinkClassNames(
                      RoutePathConstants.Question
                    )}
                  >
                    <FontAwesomeIcon icon={faQuestion} className="nav-icon" />
                    <p>Pytania</p>
                  </Link>
                </li>
              )}
              {containsAny(user.permissions, [
                PermissionConstants.User_List,
              ]) && (
                <li className="nav-item" >
                  <Link
                    to={`/${RoutePathConstants.Questionnaire}`}
                    className={getNavLinkClassNames(
                      RoutePathConstants.Questionnaire,
                      RoutePathConstants.Question
                    )}
                  >
                    <FontAwesomeIcon
                      icon={faPersonCircleQuestion}
                      className="nav-icon"
                    />
                    <p>Ankiety</p>
                  </Link>
                </li>
              )}
              {containsAll(user.permissions, [
                PermissionConstants.Calendar,
              ]) && (
                <li className="nav-item" >
                  <Link
                    to={`/${RoutePathConstants.Calendar}`}
                    className={getNavLinkClassNames(
                      RoutePathConstants.Calendar
                    )}
                  >
                    <FontAwesomeIcon
                      icon={faCalendarDays}
                      className="nav-icon"
                    />
                    <p>Kalendarz</p>
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </nav>
      </div>
    </aside>
  );
}

export default MainSidebar;
